<template>
    <div class="select_dialog">
      <div v-if="!isShowAlert" class="select_dialog_box">
        <!--弹出框头部-->
        <div class="select_dialog_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_box_content">
          <div v-if="showType === 'forgetPwd'" class="select_dialog_box_forget">
            <div>
              <label>原密码：</label>
              <input type="password" title="原密码" v-model.trim="oldPwd" @keyup.enter="submitBtn()">
            </div>
            <div>
              <label>新密码：</label>
              <input type="password" title="新密码" v-model.trim="newPwd" @keyup.enter="submitBtn()">
            </div>
            <div>
              <label>确认密码：</label>
              <input type="password" title="确认密码" v-model.trim="newConfirmPwd" @keyup.enter="submitBtn()">
            </div>
            <div class="warn">
              {{errorTxt}}
            </div>
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_box_bottom">
          <button class="btn_normal" @click="submitBtn()">提交</button>
          <button class="btn_cancel" @click="cancelBtn('')">取消</button>
        </div>
      </div>

      <!--弹出框-->
      <alert-dialog v-if="isShowAlert" :show-msg="'密码修改成功。系统即将退出，请采用新密码重新进行登录。'" @confirm="confirmBtn"></alert-dialog>
    </div>
</template>

<script type="es6">
  import AlertDialog from './alert-dialog';

    export default {
        name: 'select-dialog',
      props: ['title', 'showType'], // showType: forgetPwd=忘记密码
      components: {AlertDialog},
      data() {
          return {
            oldPwd: '', // 原密码
            newPwd: '', // 新密码
            newConfirmPwd: '', // 确认密码
            errorTxt: '', // 错误提示
            isShowAlert: false // 是否显示弹出框
          }
      },
      methods: {
          // 提交按钮
          submitBtn() {
            if (this.showType === 'forgetPwd') {
              if (!this.oldPwd) {
                this.errorTxt = '请输入原密码';
              } else if (!this.newPwd) {
                this.errorTxt = '请输入新密码';
              } else if (!this.newConfirmPwd) {
                this.errorTxt = '请输入确认密码';
              } else if (this.newPwd !== this.newConfirmPwd) {
                this.errorTxt = '两次密码不一致，请重新输入';
              } else {
                // this.isShowAlert = true;
                this.changeUserPwd();
              }
            }
          },

        // 修改密码
        changeUserPwd() {
          const params = {
            oldWord: this.oldPwd,
            newWord: this.newPwd
          };
          this.$axios.post(this.Global.changeUserPwd, params).then((res) => {
            if (!res.data.errorMsg.length) {
              this.isShowAlert = true;
            } else {
              this.errorTxt = res.data.errorMsg;
            }
          });
        },

          // 取消按钮
        cancelBtn(showType) {
            this.$emit('cancelbtn', {isShow: false, showType: showType});
        },

        // 接受弹出框传送的数据
        confirmBtn(e) {
          console.log(e);
          this.isShowAlert = false;
          sessionStorage.clear('token');
          sessionStorage.clear('userId');
          sessionStorage.clear('userName');
          sessionStorage.clear('loginTimeout');
          this.$router.push({
            path: '/'
          });
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/base-color";
  @import "../../assets/css/style";

  .select_dialog {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 996;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.2);
    display: flex;
    justify-content: center;
    align-items: center;

    .select_dialog_box {
      width: 520px;
      background-color: #ffffff;

      .select_dialog_box_top {
        width: 100%;
        height: 50px;
        line-height: 50px;
        background-color: rgba(247, 247, 248, 1);
        border-bottom: 1px solid #eeeeee;

        p {
          width: 94%;
          margin: auto;
        }
      }

      .select_dialog_box_content {

        .select_dialog_box_forget {
          width: 80%;
          margin: 30px auto 0;

          &>div {
            margin-bottom: 20px;

            label {
              display: inline-block;
              width: 70px;
              text-align: left;
              margin-right: 10px;
            }

            input {
              width: 70%;
            }

            &.warn {
              width: 60%;
              height: 20px;
              line-height: 20px;
              margin: -10px auto 0;
              color: #ff0000;
            }
          }
        }
      }

      .select_dialog_box_bottom {
        width: 100%;
        margin-top: 15px;
        margin-bottom: 30px;
        text-align: right;

        button {
          margin-right: 30px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public-component/select-dialog.vue